import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ClientIdentificationRequest } from '@api/src/models/AgentApi/Contract/client-identification-request';
import { ListIdtypeXResponse } from '@api/src/models/AgentApi/Contract/list-idtype-x-response';
import { SellerSettings } from '@api/src/models/AgentApi/Contract/seller-settings';
import { ErrorResponse } from '@core/error/error-response.model';
import { getErrorProp } from '@core/operators/start-with-errors';
import { getLoadingProp } from '@core/operators/start-with-loading';
import { StartWithUnit } from '@core/operators/start-with-unit';
import { UserState } from '@core/user/user.state';
import { AbstractFormHandlers } from '@shared/components/form/abstract-form/abstract-form.component';
import { SelectOption } from '@shared/components/form/form-select/select-option.model';
import { ClientState } from '@shared/state/client.state';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ClientSearchForm } from './client-search-form/client-search-form';

@Component({
    selector: 'app-client-search',
    imports: [ClientSearchForm, AsyncPipe],
    templateUrl: './client-search.html',
    styleUrl: './client-search.scss',
})
export class ClientSearch {
    readonly #clientState: ClientState = inject(ClientState);
    readonly #userState: UserState = inject(UserState);

    public readonly sellerSettings$: Observable<SellerSettings> = this.#userState.sellerSettings$;
    public readonly termCode$: Observable<string> = this.#userState.termCode$;
    public readonly loading$: Observable<boolean> = this.#clientState.loading$.pipe(
        getLoadingProp(StartWithUnit.ClientSearch),
    );
    public readonly error$: Observable<ErrorResponse> = this.#clientState.errors$.pipe(
        getErrorProp(StartWithUnit.ClientSearch),
    );
    public readonly mediumTypes$: Observable<SelectOption<ListIdtypeXResponse>[]> = this.#userState.mediumTypes$.pipe(
        filter(Boolean),
        map((response: ListIdtypeXResponse[]) =>
            response.map((item: ListIdtypeXResponse) => ({
                id: item.mediumType,
                name: item.name,
                rawData: item,
            })),
        ),
    );

    public readonly handlersForm: AbstractFormHandlers = {
        handlerSubmit: (body: ClientIdentificationRequest) => this.#clientState.searchClient(body),
    };
}
